import { useTranslations } from 'contexts/Translation'
import { HeaderBreadcrumbs, Spinner } from 'components'
import { PageWrapper, Row, Col } from '@qonsoll/react-design'
import { useParams, useHistory } from 'react-router-dom'
import { RewardAdvancedView } from 'domains/Reward/components'
import PATHS from 'pages/paths'
import { generatePath } from 'react-router-dom'
import { PageActions } from 'components'
import { useDocument } from 'services/api/firebase'
import { COLLECTIONS } from '__constants__'

const RewardShowPage = (props) => {
  /* Getting translations instance */
  const { t } = useTranslations()
  /* Getting history instance */
  const history = useHistory()
  /* Getting params from router */
  const params = useParams()
  /* Fetching document data from useDocument hook */
  const [reward, loading] = useDocument({
    ref: COLLECTIONS.REWARDS + '/' + params.rewardId
  })

  /* Configuring page header */
  const headingProps = {
    title: reward?.name || t('Reward show'),
    titleSize: 3,
    marginBottom: 3,
    textAlign: 'left'
  }

  /* Getting id from params */
  const { rewardId } = params

  /* Configuring page actions */
  const actions = { edit: true }

  /* Function to handle back click */
  const handleBack = () => history.goBack()
  /* Handling opening of the edit page */
  const handleEdit = () => {
    const pathParams = { rewardId }
    const path = generatePath(PATHS.AUTHENTICATED.REWARD_EDIT, pathParams)
    history.push(path)
  }

  return (
    <PageWrapper
      action={<PageActions actions={actions} onEdit={handleEdit} />}
      onBack={handleBack}
      breadcrumbs={<HeaderBreadcrumbs />}
      headingProps={headingProps}>
      <Row noGutters>
        {loading ? (
          <Col>
            <Spinner height="70vh" text={t('Reward loading')} />
          </Col>
        ) : (
          <Col cw={12}>
            <RewardAdvancedView reward={reward} />
          </Col>
        )}
      </Row>
    </PageWrapper>
  )
}

export default RewardShowPage
